import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { Snackbar } from '@xo-union/tk-component-alerts';
import { compose } from '@xo-union/react-css-modules';
import { clearToast } from '../../utilities/reducers/favorite-redux';
import styles from './styles.css';

export class ToastContainer extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      hiddenDom: !props.toast,
    };
  }

  toastContainer = createRef();
  snackbar = createRef();

  componentDidMount() {
    const engagementRingProgressBar = document.getElementsByClassName('instructions')
    if (engagementRingProgressBar.length) {
      this.toastContainer.current.classList.add(styles.engagementRingToastContainer)
    }
  }

  componentDidUpdate() {
    if (this.props.toast) {
      const { clearToast, toast } = this.props
      this.setState({ hiddenDom: false }, () => {
        this.snackbar.current.showAndDismiss({
          data: toast,
          dismissTimeout: 4000,
        });
      });
      clearToast();
    }
  }

  render() {
    const { hiddenDom } = this.state;
    const closeBtnClasses = compose(styles);

    return (
      <div className={styles['toast-container']} ref={this.toastContainer}>
        <Snackbar ref={this.snackbar} classes={closeBtnClasses} fixedToRelative />
      </div>
    )
  }
}

export function mapStateToProps(state) {
  return {
    toast: state.favoriteData.toast
  };
}

export const mapDispatchToProps = {
  clearToast: clearToast
};

export default connect(mapStateToProps, mapDispatchToProps)(ToastContainer);
